/**
 * Remembers whether the player folded the first-steps guide away. sessionStorage keeps it for the
 * tab's session, localStorage across visits; both can throw (private windows, blocked site data),
 * so every access is wrapped and the guide works without them.
 */
const KEY = 'galaxis.guide.collapsed';

export function readGuideCollapsed(): boolean {
  for (const storage of ['sessionStorage', 'localStorage'] as const) {
    try {
      const v = window[storage].getItem(KEY);
      if (v === '1' || v === '0') return v === '1';
    } catch { /* storage unavailable */ }
  }
  // Nothing remembered: phones (<768 px wide) and landscape phones (<500 px tall) start folded so the map stays clear
  return window.innerWidth < 768 || window.innerHeight < 500;
}

export function writeGuideCollapsed(collapsed: boolean): void {
  for (const storage of ['sessionStorage', 'localStorage'] as const) {
    try { window[storage].setItem(KEY, collapsed ? '1' : '0'); } catch { /* storage unavailable */ }
  }
}
